import { render, staticRenderFns } from "./m-list-signatarios.vue?vue&type=template&id=976e3496&"
import script from "./m-list-signatarios.vue?vue&type=script&lang=js&"
export * from "./m-list-signatarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports